import React from 'react';

const PostCommentReply = (props) => ( <div className="engage_the-comment_reply">{props.children}</div> );

export default PostCommentReply;